import AbstractPopupMediator from "../../../../../shared/src/ranj/app/ui/AbstractPopupMediator";
import GameStatus from "../model/GameStatus";
import Anchor from "../../../../../shared/lib/html5-software-library/src/ranj/layout/Anchor";

export default class LevelPrepareOverlayMediator extends AbstractPopupMediator {
    constructor(target, dispatcher, languagePack, layoutManager, soundManager, gameConfig, gameModel) {
        super(target, dispatcher, languagePack, layoutManager, soundManager);
        this._gameConfig = gameConfig;
        this._gameModel = gameModel;
    }

    initialize() {
        super.initialize();
        this._target.alpha = 0;

        this.anchorObject(this._target, Anchor.C);

        const prefix = this.getText(this._gameModel.status == GameStatus.PRACTICE ? "game.level.preparePractice" : "game.level.prepare");
        this.applyText(this._target.instructionLabel, `${prefix} ${this._gameModel.puzzleNumber}`);
        // Adaptive retry level
        if(this._gameModel.sequenceIndex > 0) {
            this.applyText(this._target.instructionLabel, this.getText("game.level.prepareRetry"));
        }
        this._target.instructionLabel.alpha = 0;

        const instructionText = this.getText("game.level.prepareInstructions");

        const speedFactor = this._gameModel.speedFactor;

        createjs.Tween.get(this._target.instructionLabel)
            .wait(500 / speedFactor)
            .to({ alpha: 1 }, 200 / speedFactor, createjs.Ease.quadIn)
            .wait(1300 / speedFactor)
            .to({ alpha: 0 }, 200 / speedFactor, createjs.Ease.quadOut)
            .wait(300 / speedFactor)
            .call(() => { this.applyText(this._target.instructionLabel, instructionText) })
            .to({ alpha: 1 }, 200 / speedFactor, createjs.Ease.quadIn)

            .wait(1500 / speedFactor)
            .call(this.close.bind(this));
    }
}